// extracted by mini-css-extract-plugin
export default {"root":"kKOFF_","field":"jPwug1","label":"IERdTo","input":"fniO3s"};